import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ModalConfirmation } from '@/lib/v2/examples';

import {
  atomRefetchAllData,
  atomTotalSelectedRows,
} from '@/modules/CampaignsModule/atoms/campaignAtom';
import { atomToggleDeleteModal } from '@/modules/CampaignsModule/atoms/modalsCampaignAtom';
import { useCampaign } from '@/modules/CampaignsModule/hooks/useCampaigns';

const DeleteCampaigns = () => {
  const { t } = useTranslation();
  const totalSelectedRows = useAtomValue(atomTotalSelectedRows);
  const setRefetchAllData = useSetAtom(atomRefetchAllData);
  const [toggleDeleteModal, setToggleDeleteModal] = useAtom(atomToggleDeleteModal);

  const { deleteCampaign } = useCampaign();

  const handleConfirmDeleteCampaigns = useCallback(async () => {
    await deleteCampaign();
    setToggleDeleteModal(false);
    setRefetchAllData(true);
  }, [setRefetchAllData, setToggleDeleteModal, deleteCampaign]);

  return (
    <ModalConfirmation
      description={
        totalSelectedRows > 1
          ? t('CAMPAIGNS_MAIN.DELETE_CAMPAIGNS.MULTIPLE.description')
          : t('CAMPAIGNS_MAIN.DELETE_CAMPAIGNS.SINGLE.description')
      }
      isOpen={toggleDeleteModal}
      textCancelButton={t('CAMPAIGNS_MAIN.DELETE_CAMPAIGNS.cancelButton')}
      textConfirmButton={t('CAMPAIGNS_MAIN.DELETE_CAMPAIGNS.successButton')}
      title={
        totalSelectedRows > 1
          ? t('CAMPAIGNS_MAIN.DELETE_CAMPAIGNS.MULTIPLE.title')
          : t('CAMPAIGNS_MAIN.DELETE_CAMPAIGNS.SINGLE.title')
      }
      onClose={setToggleDeleteModal}
      onConfirmButton={handleConfirmDeleteCampaigns}
    />
  );
};

export default DeleteCampaigns;
